var Reflux = require("reflux");
var agendorAPI = require("app/util/api/agendor-api");
var usersAPI = require("app/util/api/users");

var ListingActions = Reflux.createActions({
    "applyFilter": {},
    "removeAllFilters": {},
    "removeFilter": {},
    "orderBy": {},
    "updateTotalResults": {},
    "updatePage": {},
    "updateDealsTotalValue": {},
    "highlightFilter": {},
    "diminishFilters": {},
    "loadSelectOptions": {children: ["completed","failed"]},
    "loadFunnelOptions": {children: ["completed", "failed"]},
    "loadDealStageOptions": {children: ["completed", "failed"]},
    "loadUserOwnerOptions": {children: ["completed","failed"]},
    "loadLeadOriginOptions": {children: ["completed","failed"]},
    "loadProducts": {children: ["completed","failed"]},
    "loadQuote": {children: ["completed","failed"]},
    "handleMoreFiltersClick": {},
    "handleFilterOverrides": {}
});

ListingActions.loadSelectOptions.listen(function(data){
  if(data.resource) {
    agendorAPI.get("/"+data.resource, {}, function(options) {
      this.completed({
        name: data.name,
        options:options
      });
    }.bind(this));
  }
});

ListingActions.loadFunnelOptions.listen(function(data) {
  if(data.resource) {
    agendorAPI.get("/funnels", {}, function(options) {
      this.completed({
        name: data.name,
        options:options
      });
    }.bind(this));
  }
});

ListingActions.loadDealStageOptions.listen(function(data) {
  if(data.resource) {
    agendorAPI.get("/deal_stages", {}, function(options) {
      this.completed({
        name: data.name,
        options:options
      });
    }.bind(this));
  }
});

ListingActions.loadUserOwnerOptions.listen(function(data){
  if(data.resource) {
    usersAPI.get({}, function(options) {
      this.completed({
        name: data.name,
        options:options
      });
    }.bind(this));
  }
});

ListingActions.loadLeadOriginOptions.listen(function(data){
  if(data.resource && data.options.length <= 1) {
    agendorAPI.get("/lead_origins", {}, function(options) {
      this.completed({
        name: data.name,
        options:options
      });
    }.bind(this));
  }
});

ListingActions.loadProducts.listen(function(){
  agendorAPI.get("/products", {}, function(data) {
    this.completed(data);
  }.bind(this));
});

ListingActions.loadQuote.listen(function(){
    agendorAPI.get("/inspirational_quote.json", {}, function(quote) {
        this.completed(quote);
    }.bind(this));
});

module.exports = ListingActions;



// WEBPACK FOOTER //
// ./app/shared/actions/listing-actions.js